// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__tJQhN","content":"style_content__Hkjy3","textRight":"style_textRight__1YRHg"};